import { useEffect, useState } from 'react';
import { apiServerDac } from '@/services/api';
import { IDisciplinaObrigatoriaData } from '@/@types/Graduacao/DisciplinasObrigatorias';
import { DisciplinasObrigatoriasComponent } from '@/components/PagesComponents/Graduacao/DisciplinasObrigatorias';

const DisciplinasObrigatorias = () => {
    const [disciplinasObrigatoriasData, setDisciplinasObrigatoriasData] = useState<IDisciplinaObrigatoriaData[]>([]);
    // Captura o ano atual do sistema
    const anoAtual = new Date().getFullYear();    
    const [ano, setAno] = useState<number>(anoAtual);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {

        const getDisciplinasObrigatoriasData = async () => {
            setIsLoading(true);
            // server-dac V2 substitui /disciplinas/allcatalog preservando { disciplinas }.
            const url = `/v2/disciplinas_catalogo/catalogo?ano=${!ano ? anoAtual : ano}`;
            apiServerDac.get(url)
                .then(response => {
                    const disciplinas = response.data.disciplinas.map((disciplina: any) => ({
                        ...disciplina,
                        COD_DISC: disciplina.COD_DISC || disciplina.COD_DISCI,
                        ano_catal: disciplina.ano_catal || disciplina.ANO_CATAL,
                    }));
                    setDisciplinasObrigatoriasData(disciplinas);
                    setIsLoading(false);
                })
                .catch(err => {
                    console.log(err);
                    setIsLoading(false);
                });
        }

        getDisciplinasObrigatoriasData();

    }, [ano]);


    return (
        <>
            <h1>Graduação - Disciplinas Obrigatórias</h1>

            <DisciplinasObrigatoriasComponent isLoading={isLoading} ano={ano} setAno={setAno} data={disciplinasObrigatoriasData} />
        </>
    )

}

export { DisciplinasObrigatorias };
